import React, { useState } from 'react';
import { Confirm, useRefresh, useNotify, useTranslate, useRecordContext } from 'react-admin';
import RateReviewIcon from '@mui/icons-material/RateReview';
import CircularProgress from '@mui/material/CircularProgress';

import IconButton from '../../common/buttons/IconButton';

import { requestReviewEvent } from '../../../services/api';

const RequestReviewButton = ({ variant, color }) => {
	const record = useRecordContext();
	const refresh = useRefresh();
	const notify = useNotify();
	const translate = useTranslate();
	const [showDialog, setShowDialog] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleConfirm = async () => {
		setLoading(true);
		const response = await requestReviewEvent(record.id);
		if (response.success) {
			refresh();
			notify(translate('Review requested'));
		}

		setLoading(false);
		handleClose();
	};

	const handleOpen = () => {
		setShowDialog(true);
	};

	const handleClose = () => {
		setShowDialog(false);
	};

	if (!record || !['draft', 'refused'].includes(record.status)) {
		return null;
	}

	return (
		<>
			<IconButton icon={loading ? <CircularProgress size={18} thickness={2} sx={{ marginRight: '10px', padding: 0 }} color="inherit" /> : <RateReviewIcon />} onClick={handleOpen} variant={variant} color={color} disabled={loading}>
				{translate('Ask for review')}
			</IconButton>
			<Confirm
				isOpen={showDialog}
				title={translate('Ask for review')}
				content={translate('Do you want to ask a review for the event') + ` ${record.title}?`}
				onConfirm={handleConfirm}
				onClose={handleClose}
				loading={loading}
			/>
		</>
	);
};

export default RequestReviewButton;